/*
 * @Author: zhaozhuo
 * @Date: 2022-02-18 11:54:58
 * @LastEditors: zhengshuhua
 * @LastEditTime: 2022-09-19 11:07:52
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\store\research\state.js
 */
import * as STATETYPES from '../stateTypes'
const state = {
	[STATETYPES.RESEARCHNAME]: '', // 研究名称
	[STATETYPES.RESEARCHCODE]: '', // 研究code
	[STATETYPES.RESEARCHINFO]: {} // 研究info
}
export default state